export const UserCircleSvgIcon = () => (
  <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.16699 12V11.3333C5.16699 9.49238 6.65938 8 8.50033 8V8C10.3413 8 11.8337 9.49238 11.8337 11.3333V12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.5 8C9.60457 8 10.5 7.10457 10.5 6C10.5 4.89543 9.60457 4 8.5 4C7.39543 4 6.5 4.89543 6.5 6C6.5 7.10457 7.39543 8 8.5 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="8.49967" cy="8.00065" r="6.66667" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
